var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"videoWrap preview",class:{ playing: _vm.isPlaying }},[_c('i',{class:_vm.previewIcon}),(_vm.isPreview)?_c('span',{staticClass:"preview-media-badge"},[_vm._v(_vm._s(_vm.statusText))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }